/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CarteRouteImport } from './routes/_carte'
import { Route as AideRouteImport } from './routes/aide'
import { Route as ConnexionRouteImport } from './routes/connexion'
import { Route as ProchesRouteImport } from './routes/proches'
import { Route as RevueRouteImport } from './routes/revue'
import { Route as TableauDeBordRouteImport } from './routes/tableau-de-bord'
import { Route as CarteIndexRouteImport } from './routes/_carte.index'
import { Route as AdminImportRouteImport } from './routes/admin.import'
import { Route as AdminSystemeRouteImport } from './routes/admin.systeme'
import { Route as AdminUtilisateursRouteImport } from './routes/admin.utilisateurs'
import { Route as TourneesIndexRouteImport } from './routes/tournees.index'
import { Route as TourneesIdRouteImport } from './routes/tournees.$id'
import { Route as CarteClientsIdRouteImport } from './routes/_carte.clients.$id'

const CarteRoute = CarteRouteImport.update({
  id: '/_carte',
  getParentRoute: () => rootRouteImport,
} as any)
const AideRoute = AideRouteImport.update({
  id: '/aide',
  path: '/aide',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnexionRoute = ConnexionRouteImport.update({
  id: '/connexion',
  path: '/connexion',
  getParentRoute: () => rootRouteImport,
} as any)
const ProchesRoute = ProchesRouteImport.update({
  id: '/proches',
  path: '/proches',
  getParentRoute: () => rootRouteImport,
} as any)
const RevueRoute = RevueRouteImport.update({
  id: '/revue',
  path: '/revue',
  getParentRoute: () => rootRouteImport,
} as any)
const TableauDeBordRoute = TableauDeBordRouteImport.update({
  id: '/tableau-de-bord',
  path: '/tableau-de-bord',
  getParentRoute: () => rootRouteImport,
} as any)
const CarteIndexRoute = CarteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CarteRoute,
} as any)
const AdminImportRoute = AdminImportRouteImport.update({
  id: '/admin/import',
  path: '/admin/import',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSystemeRoute = AdminSystemeRouteImport.update({
  id: '/admin/systeme',
  path: '/admin/systeme',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUtilisateursRoute = AdminUtilisateursRouteImport.update({
  id: '/admin/utilisateurs',
  path: '/admin/utilisateurs',
  getParentRoute: () => rootRouteImport,
} as any)
const TourneesIndexRoute = TourneesIndexRouteImport.update({
  id: '/tournees/',
  path: '/tournees/',
  getParentRoute: () => rootRouteImport,
} as any)
const TourneesIdRoute = TourneesIdRouteImport.update({
  id: '/tournees/$id',
  path: '/tournees/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CarteClientsIdRoute = CarteClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => CarteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof CarteIndexRoute
  '/aide': typeof AideRoute
  '/connexion': typeof ConnexionRoute
  '/proches': typeof ProchesRoute
  '/revue': typeof RevueRoute
  '/tableau-de-bord': typeof TableauDeBordRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/systeme': typeof AdminSystemeRoute
  '/admin/utilisateurs': typeof AdminUtilisateursRoute
  '/tournees/$id': typeof TourneesIdRoute
  '/tournees/': typeof TourneesIndexRoute
  '/clients/$id': typeof CarteClientsIdRoute
}
export interface FileRoutesByTo {
  '/aide': typeof AideRoute
  '/connexion': typeof ConnexionRoute
  '/proches': typeof ProchesRoute
  '/revue': typeof RevueRoute
  '/tableau-de-bord': typeof TableauDeBordRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/systeme': typeof AdminSystemeRoute
  '/admin/utilisateurs': typeof AdminUtilisateursRoute
  '/tournees/$id': typeof TourneesIdRoute
  '/': typeof CarteIndexRoute
  '/tournees': typeof TourneesIndexRoute
  '/clients/$id': typeof CarteClientsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_carte': typeof CarteRouteWithChildren
  '/aide': typeof AideRoute
  '/connexion': typeof ConnexionRoute
  '/proches': typeof ProchesRoute
  '/revue': typeof RevueRoute
  '/tableau-de-bord': typeof TableauDeBordRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/systeme': typeof AdminSystemeRoute
  '/admin/utilisateurs': typeof AdminUtilisateursRoute
  '/tournees/$id': typeof TourneesIdRoute
  '/_carte/': typeof CarteIndexRoute
  '/tournees/': typeof TourneesIndexRoute
  '/_carte/clients/$id': typeof CarteClientsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aide'
    | '/connexion'
    | '/proches'
    | '/revue'
    | '/tableau-de-bord'
    | '/admin/import'
    | '/admin/systeme'
    | '/admin/utilisateurs'
    | '/tournees/$id'
    | '/tournees/'
    | '/clients/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/aide'
    | '/connexion'
    | '/proches'
    | '/revue'
    | '/tableau-de-bord'
    | '/admin/import'
    | '/admin/systeme'
    | '/admin/utilisateurs'
    | '/tournees/$id'
    | '/'
    | '/tournees'
    | '/clients/$id'
  id:
    | '__root__'
    | '/_carte'
    | '/aide'
    | '/connexion'
    | '/proches'
    | '/revue'
    | '/tableau-de-bord'
    | '/admin/import'
    | '/admin/systeme'
    | '/admin/utilisateurs'
    | '/tournees/$id'
    | '/_carte/'
    | '/tournees/'
    | '/_carte/clients/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CarteRoute: typeof CarteRouteWithChildren
  AideRoute: typeof AideRoute
  ConnexionRoute: typeof ConnexionRoute
  ProchesRoute: typeof ProchesRoute
  RevueRoute: typeof RevueRoute
  TableauDeBordRoute: typeof TableauDeBordRoute
  AdminImportRoute: typeof AdminImportRoute
  AdminSystemeRoute: typeof AdminSystemeRoute
  AdminUtilisateursRoute: typeof AdminUtilisateursRoute
  TourneesIdRoute: typeof TourneesIdRoute
  TourneesIndexRoute: typeof TourneesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_carte': {
      id: '/_carte'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CarteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aide': {
      id: '/aide'
      path: '/aide'
      fullPath: '/aide'
      preLoaderRoute: typeof AideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connexion': {
      id: '/connexion'
      path: '/connexion'
      fullPath: '/connexion'
      preLoaderRoute: typeof ConnexionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proches': {
      id: '/proches'
      path: '/proches'
      fullPath: '/proches'
      preLoaderRoute: typeof ProchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revue': {
      id: '/revue'
      path: '/revue'
      fullPath: '/revue'
      preLoaderRoute: typeof RevueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tableau-de-bord': {
      id: '/tableau-de-bord'
      path: '/tableau-de-bord'
      fullPath: '/tableau-de-bord'
      preLoaderRoute: typeof TableauDeBordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_carte/': {
      id: '/_carte/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof CarteIndexRouteImport
      parentRoute: typeof CarteRoute
    }
    '/admin/import': {
      id: '/admin/import'
      path: '/admin/import'
      fullPath: '/admin/import'
      preLoaderRoute: typeof AdminImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/systeme': {
      id: '/admin/systeme'
      path: '/admin/systeme'
      fullPath: '/admin/systeme'
      preLoaderRoute: typeof AdminSystemeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/utilisateurs': {
      id: '/admin/utilisateurs'
      path: '/admin/utilisateurs'
      fullPath: '/admin/utilisateurs'
      preLoaderRoute: typeof AdminUtilisateursRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournees/': {
      id: '/tournees/'
      path: '/tournees'
      fullPath: '/tournees/'
      preLoaderRoute: typeof TourneesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournees/$id': {
      id: '/tournees/$id'
      path: '/tournees/$id'
      fullPath: '/tournees/$id'
      preLoaderRoute: typeof TourneesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_carte/clients/$id': {
      id: '/_carte/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof CarteClientsIdRouteImport
      parentRoute: typeof CarteRoute
    }
  }
}

interface CarteRouteChildren {
  CarteIndexRoute: typeof CarteIndexRoute
  CarteClientsIdRoute: typeof CarteClientsIdRoute
}

const CarteRouteChildren: CarteRouteChildren = {
  CarteIndexRoute: CarteIndexRoute,
  CarteClientsIdRoute: CarteClientsIdRoute,
}

const CarteRouteWithChildren = CarteRoute._addFileChildren(CarteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CarteRoute: CarteRouteWithChildren,
  AideRoute: AideRoute,
  ConnexionRoute: ConnexionRoute,
  ProchesRoute: ProchesRoute,
  RevueRoute: RevueRoute,
  TableauDeBordRoute: TableauDeBordRoute,
  AdminImportRoute: AdminImportRoute,
  AdminSystemeRoute: AdminSystemeRoute,
  AdminUtilisateursRoute: AdminUtilisateursRoute,
  TourneesIdRoute: TourneesIdRoute,
  TourneesIndexRoute: TourneesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
